import React from 'react';
import { AsyncSelect, AsyncSelectImplementationProps, GetOptions } from './async-select';
import { useApiClient } from '~/api-client';
import { OTHER_OPTION } from '../option';
import { VehiclescodesResource } from '@mark43/rms-api';

type VehicleModelSelectProps = Omit<AsyncSelectImplementationProps, 'minimumQueryLength'> & {
    vehicleMakeId?: number;
};
export const VehicleModelSelect = React.forwardRef<HTMLDivElement, VehicleModelSelectProps>(
    function VehicleModelSelect(props: VehicleModelSelectProps, ref): React.ReactElement {
        const apiClient = useApiClient();
        const getOptions: GetOptions = React.useCallback(
            (query: string) => {
                return apiClient
                    .request<VehiclescodesResource.GetVehicleModels>({
                        method: 'GET',
                        url: 'vehicles/codes/models/',
                        params: {
                            ...(query ? { q: query } : {}),
                            from: 0,
                            size: 50,
                            vehicle_make_id: props.vehicleMakeId,
                        },
                        service: 'RMS',
                    })
                    .then((response) => {
                        const data = response.data.data?.vehicleModels;
                        if (data) {
                            const options = data.map((datum) => ({
                                value: datum.id,
                                label: datum.modelName,
                            }));
                            return options;
                        } else {
                            return [];
                        }
                    })
                    .then((options) => {
                        // Always append the `other_option`
                        return options.concat(OTHER_OPTION);
                    });
            },
            [apiClient, props.vehicleMakeId]
        );
        return (
            <AsyncSelect
                {...props}
                ref={ref}
                getOptions={getOptions}
                debounceTimer={500}
                fetchOptionsOnMenuOpen={true}
            />
        );
    }
);
